import { FbProvider } from '@featbit/react-client-sdk'
import React from 'react'
import FeatureFlagsProvider from './FeatureFlagsProvider'
import { useFeatBitClientOptions } from './hooks'

/**
 * Provider to initialize the FeatBit SDK and return camelCased flag keys
 */
const FeatBitProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { fbClientOptions, isFbClientOptionsReady } = useFeatBitClientOptions()

  return (
    <FbProvider
      options={fbClientOptions}
      reactOptions={{
        useCamelCaseFlagKeys: true,
      }}
      deferInitialization
    >
      <FeatureFlagsProvider isFbClientOptionsReady={isFbClientOptionsReady}>{children}</FeatureFlagsProvider>
    </FbProvider>
  )
}

export default FeatBitProvider
